/**
 * Toggle - 토글 스위치 컴포넌트
 *
 * @param checked / onChange - 제어 상태
 * @param withText - true이면 ON/OFF 텍스트 표시
 * @param withIcon - true이면 체크/X 아이콘 표시
 */
'use client';

import React from 'react';
import styles from './Toggle.module.css';

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  sublabel?: string;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  withText?: boolean;
  withIcon?: boolean;
}

export default function Toggle({
  checked,
  onChange,
  label,
  sublabel,
  disabled = false,
  size = 'md',
  color,
  withText = false,
  withIcon = false,
}: ToggleProps) {
  const customStyle =
    color && checked ? ({ '--toggle-checked-color': color } as React.CSSProperties) : undefined;

  return (
    <label className={`${styles.toggle} ${disabled ? styles.disabled : ''}`}>
      {(label || sublabel) && (
        <span className={styles.labelGroup}>
          {label && <span className={styles.label}>{label}</span>}
          {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
        </span>
      )}
      <span
        className={`${styles.switch} ${styles[size]} ${withText ? styles.withText : ''} ${withIcon ? styles.withIcon : ''}`}
        role="switch"
        aria-checked={checked}
        style={customStyle}
      >
        <input
          type="checkbox"
          className={styles.input}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <span className={styles.track}>
          {withText && <span className={styles.trackText}>{checked ? 'ON' : 'OFF'}</span>}
          {withIcon && (
            <span className={styles.thumbIcon}>
              {checked ? (
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 5.5L3.5 7.5L8.5 2.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.5 2.5L7.5 7.5M7.5 2.5L2.5 7.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </span>
          )}
        </span>
      </span>
    </label>
  );
}
